import React, { Component }  from 'react'
import styled from 'styled-components'
import CloseIcon from '../../../common/icons/CloseIcon2'

const Background = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${props => (props.published ? 'none' : '#F4F4F4')};
  padding: ${props => (props.published ? 'none' : '5px 10px')};
  margin-left: ${props => (props.published ? 'none' : '12px')};
  max-width: fit-content;
  margin-bottom: 7px;
`
const Left = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Right = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Link = styled.a`
  color: #3399CC;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 19px;
`
const FileUploadedIcon = styled.i`
  display: flex;
  justify-content: flex-start;
  color: #56565a;
  margin-right: 5px;
`
const Clickable = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
`

export default class File extends Component {
  onFileDeleteClick = () => {
    const { filename, onFileDeleteClick } = this.props
    onFileDeleteClick(filename)
  }

  render(){
    const { filename, link, hideClose, published } = this.props
    return (
      <Background published={published}>
        <Left>
          <FileUploadedIcon className="fa fa-file-text-o">
            {' '}
          </FileUploadedIcon>
          {!link && filename}
          {link && (
            <Link href={link} target="_blank">
              {filename}
            </Link>
          )}
        </Left>
        {!hideClose && (
          <Right>
            <Clickable onClick={this.onFileDeleteClick}>
              <CloseIcon color="#56565A"/>
            </Clickable>
          </Right>
        )}
      </Background>
    )
  }
}
